if (!customElements.get('load-more')) {
  class LoadMore extends HTMLElement {
    constructor() {
      super();

      this.ajaxSectionToLoad = 'collection-products-content';

      this.currentPageValue = +this.querySelector('[data-current-page]').value;
      this.totalPagesValue = +this.querySelector('[data-total-pages]').value;
      this.totalItemsValue = +this.querySelector('[data-total-items]').value;
      this.totalItemsOnLastPageValue = +this.querySelector('[data-items-on-last-page]').value;

      this.loadedPages = [];
      // add the current page to the array if it does not exist yet
      if (this.loadedPages.indexOf(this.currentPageValue) === -1) {
        this.loadedPages.push(this.currentPageValue);
      }

      this.initLoadMoreButtons();
    }

    /**
     * initLoadMoreButtons
     * @description Create the load more/prev buttons. Is also called again after fetch is done
     */
    initLoadMoreButtons() {
      // hide the buttons based on the page displayed
      this.totalPagesValue === this.currentPageValue &&
      this.querySelector('[data-load-trigger="next"]') != null
        ? this.querySelector('[data-load-trigger="next"]').classList.add('hidden')
        : null;

      this.currentPageValue === 1 && this.querySelector('[data-load-trigger="prev"]') != null
        ? this.querySelector('[data-load-trigger="prev"]').classList.add('hidden')
        : null;

      this.loadTrigger = this.querySelectorAll('[data-load-trigger]');
      this.loadTrigger.forEach((trigger) => {
        trigger.addEventListener('click', this.loadItems.bind(this));

        // start loading the next items when the Load next button comes to view
        if (trigger.dataset.loadTrigger == 'next') {
          const loadNextButton = this.querySelector('[data-load-trigger="next"]');
          const observerCallback = (payload) => {
            if (payload[0].isIntersecting) {
              loadNextButton.click();
              // stop observing after the button is triggered
              this.observer.unobserve(loadNextButton);
            }
          };
          this.observer = new IntersectionObserver(observerCallback);
          this.observer.observe(loadNextButton);
        }
      });
    }

    /**
     * loadItems
     * @description Gets the url to fetch and toggles the load items/loading text
     * @param {Object} event
     */
    loadItems(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const linkElement = event.target.closest('a');
      const direction = linkElement.dataset.loadTrigger;
      linkElement.querySelector('[data-load-text]').classList.add('hidden');
      linkElement.querySelector('[data-loader]').classList.remove('hidden');

      const url = `${linkElement.href}&section_id=${this.ajaxSectionToLoad}`;
      this.renderElementsFromFetch(url, linkElement.href, direction);
    }

    /**
     * renderElementsFromFetch
     * @description Renders the products based on the fetch url data.
     * @param {String} url
     * @param {String} page
     * @param {String} direction
     */
    renderElementsFromFetch(url, page, direction) {
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          let wrapperID = '#products';

          if (!html.querySelector(`${wrapperID}`)) {
            return;
          }

          let elementsWrapper = document.querySelector('#CollectionProductGrid');
          let wrapperIDSelector = '[data-products-list]';

          // update the wrapper with the new elements (products)
          const newContent = html.querySelector(`${wrapperID} ${wrapperIDSelector}`).innerHTML;
          const newElement = document.createRange().createContextualFragment(newContent);

          // depending on the direction of the click, append or prepend the products and update the pagination
          if (direction == 'next') {
            elementsWrapper.querySelector(`${wrapperIDSelector}`).append(newElement);
            // update the pagination
            const paginationNextHtml = html.querySelector('[data-pagination-next]').innerHTML;
            elementsWrapper.querySelector('[data-pagination-next]').innerHTML = paginationNextHtml;
          } else {
            elementsWrapper.querySelector(`${wrapperIDSelector}`).prepend(newElement);
            // update the pagination
            const paginationPrevHtml = html.querySelector('[data-pagination-prev]').innerHTML;
            elementsWrapper.querySelector('[data-pagination-prev]').innerHTML = paginationPrevHtml;
          }

          // update the variables because the returned amount of products will have different pagination values
          this.currentPageValue = +html.querySelector('[data-current-page]').value;
          this.totalPagesValue = +html.querySelector('[data-total-pages]').value;
          this.totalItemsValue = +html.querySelector('[data-total-items]').value;
          this.totalItemsOnLastPageValue = +html.querySelector('[data-items-on-last-page]').value;

          // update the array of loaded pages
          if (this.loadedPages.indexOf(this.currentPageValue) === -1) {
            this.loadedPages.push(this.currentPageValue);
          }

          // reload the function since variables might have been changed
          this.initLoadMoreButtons(true);

          // update url
          this.updateURLHash(page);

          // update the hidden input with the new value
          this.querySelector('[data-current-page]').value = page.split('page=')[1];

          // reinitialize rating snippets
          if (typeof loadReviewsIoRatingSnippets === 'function') loadReviewsIoRatingSnippets();
        });
    }

    /**
     * updateURLHash
     * @param {String} url
     */
    updateURLHash(url) {
      history.pushState('', '', url);
    }
  }

  window.LoadMore = LoadMore;

  customElements.define('load-more', LoadMore);
}
